/**
 * Sticky jump links: publish their height so anchors and the hero clear them,
 * and mark the bar scrollable when its links overflow (the static fade).
 */
export default function initJumpLinks() {
	const bar = document.querySelector('[data-awdd-jump-links]');
	if (!bar) return;
	const root = document.documentElement;
	const scroller = bar.querySelector('.subnav');
	const wrap = bar.querySelector('.subnav-wrap');
	const publish = () => {
		root.style.setProperty('--subnav-h', `${bar.offsetHeight}px`);
		if (scroller && wrap) wrap.classList.toggle('is-scrollable', scroller.scrollWidth > scroller.clientWidth + 1);
	};
	publish();
	if ('ResizeObserver' in window) {
		const ro = new ResizeObserver(publish);
		ro.observe(bar);
		if (scroller) ro.observe(scroller);
	}
}
